webpackJsonp([41],{

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PROPOSE_NOMINEE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROPOSE_NOMINEE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_VOTED_NOMINATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_VOTED_NOMINATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_VOTED_NOMINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VOTE_NOMINEE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VOTE_NOMINEE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return VOTE_NOMINEE_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_LIST_NOMINATIONS_SUCCESS; });
/* unused harmony export FETCH_LIST_NOMINATIONS_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_CURRENT_NOMINATION_SUCCESS; });
/* unused harmony export SET_CURRENT_NOMINATION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS; });
var PROPOSE_NOMINEE_SUCCESS = 'PROPOSE_NOMINEE_SUCCESS';
var PROPOSE_NOMINEE_FAILURE = 'PROPOSE_NOMINEE_FAILURE';

var FETCH_VOTED_NOMINATION_SUCCESS = 'FETCH_VOTED_NOMINATION_SUCCESS';
var FETCH_VOTED_NOMINATION_FAILURE = 'FETCH_VOTED_NOMINATION_FAILURE';
var CLEAR_VOTED_NOMINATION = 'CLEAR_VOTED_NOMINATION';

var VOTE_NOMINEE_SUCCESS = 'VOTE_NOMINEE_SUCCESS';
var VOTE_NOMINEE_FAILURE = 'VOTE_NOMINEE_FAILURE';

var VOTE_NOMINEE_CLOSED = 'VOTE_NOMINEE_CLOSED';

var FETCH_LIST_NOMINATIONS_SUCCESS = 'FETCH_LIST_NOMINATIONS_SUCCESS';
var FETCH_LIST_NOMINATIONS_FAILURE = 'FETCH_LIST_NOMINATIONS_FAILURE';

var SET_CURRENT_NOMINATION_SUCCESS = 'SET_CURRENT_NOMINATION_SUCCESS';
var SET_CURRENT_NOMINATION_FAILURE = 'SET_CURRENT_NOMINATION_FAILURE';

var SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS = 'SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS';
var FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS = 'FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS';

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resolvePageComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveAppComponent; });
var resolvePageComponent = function resolvePageComponent(regionTID, pageTID) {
  switch (regionTID) {
    case '72':
    case '29':
      return function () {
        return __webpack_require__(595)("./" + pageTID + '.vue');
      };

    case '59':
    case '54':
    case '75':
    case '66':
    case '63':
    case '74':
      return function () {
        return __webpack_require__(596)("./" + pageTID + '.vue');
      };
    default:
  }

  return function () {
    return __webpack_require__(594)("./" + pageTID + '.vue');
  };
};

var resolveAppComponent = function resolveAppComponent(regionTID) {
  switch (regionTID) {
    case '72':
    case '29':
      return function () {
        return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 609));
      };

    case '59':
    case '54':
    case '75':
    case '66':
    case '63':
    case '74':
      return function () {
        return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 622));
      };
    default:
  }

  return function () {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 597));
  };
};

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Nomination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_urls__ = __webpack_require__(20);









var Nomination = function () {
  function Nomination(data) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Nomination);

    this.data = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, data);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Nomination, [{
    key: "getId",
    value: function getId() {
      return this.data.id;
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.data.name;
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      if (this.data.description) {
        return this.data.description;
      }
      return '';
    }
  }, {
    key: "getLink",
    value: function getLink() {
      return this.data.link;
    }
  }, {
    key: "getWinnerName",
    value: function getWinnerName() {
      return this.data.winnerName;
    }
  }, {
    key: "getItemIconStyle",
    value: function getItemIconStyle() {
      return this.data.iconImage !== "" ? { backgroundImage: "url(" + this.data.iconImage + ")" } : null;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.data.type;
    }
  }]);

  return Nomination;
}();

var normalizeAwardPath = function normalizeAwardPath(path) {
  if (typeof path !== "string" || path === "") {
    return "";
  }

  var normalizedPath = path.split(/[?#]/)[0].replace(/^\/award(?=\/|$)/, "").replace(/\/+$/, "");

  return normalizedPath === "" ? "/" : normalizedPath;
};

var findNominationByPath = function findNominationByPath(nominations, path) {
  var normalizedPath = normalizeAwardPath(path);

  return nominations.find(function (nomination) {
    return normalizeAwardPath(nomination.link) === normalizedPath;
  });
};

var getInitialNomination = function getInitialNomination() {
  if (typeof window === "undefined" || !window.CURRENT_RUBRIC) {
    return null;
  }

  var currentRubric = window.CURRENT_RUBRIC;
  var currentRegion = parseInt(window.CONTEXT_REGION, 10);
  var currentPath = normalizeAwardPath(window.location.pathname);
  var rubricLink = normalizeAwardPath(currentRubric.link);
  var isVotesRubricPage = /^\/votes\/[^/]+$/.test(currentPath);
  var isSameRegion = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(currentRegion) || typeof currentRubric.region === "undefined" || Number(currentRubric.region) === currentRegion;
  var isSamePath = rubricLink !== "" && currentPath === rubricLink;

  return isVotesRubricPage && isSameRegion && isSamePath ? currentRubric : null;
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _mutations;

  var initialNomination = getInitialNomination();

  var state = {
    nomination: initialNomination,
    nominations: [],
    nominees: [],
    path: null,
    isNominationsLoading: false,
    nominationsLoadError: null
  };

  var actions = {
    setCurrentPath: function setCurrentPath(_ref, path) {
      var commit = _ref.commit;

      commit("path", path);
    },
    setNomination: function setNomination(_ref2, nomination) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_CURRENT_NOMINATION_SUCCESS */], nomination);
    },
    loadNominees: function loadNominees(_ref3, params) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          state = _ref3.state;

      var host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      var url = "" + (host + __WEBPACK_IMPORTED_MODULE_7__constants_urls__["O" /* NOMINATION_API_URL */]) + state.nomination.id + "/";

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { withCredentials: true }).then(function (result) {
        commit("loadNominees", result.data);

        dispatch("loader/decrement", {}, { root: true });
      }).catch(function (error) {
        console.log(error);
        dispatch("loader/decrement", {}, { root: true });
      });
    },
    loadNominations: function loadNominations(_ref4, params) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch,
          state = _ref4.state;

      var host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });
      commit("setNominationsLoading", true);
      commit("setNominationsLoadError", null);

      var currentYear = "";

      if (params && params.year) {
        currentYear = "?year=" + params.year;
      }

      var url = host + __WEBPACK_IMPORTED_MODULE_7__constants_urls__["P" /* NOMINEES_API_URL */] + currentYear;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url, { withCredentials: true }).then(function (_ref5) {
        var nominations = _ref5.data;

        commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["l" /* FETCH_LIST_NOMINATIONS_SUCCESS */], nominations);

        if (state.path !== null) {
          var currentNomination = findNominationByPath(nominations, state.path);

          commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_CURRENT_NOMINATION_SUCCESS */], currentNomination || state.nomination);
        }

        dispatch("loader/decrement", {}, { root: true });
      }).catch(function (error) {
        console.log(error);
        commit("setNominationsLoadError", "Не удалось загрузить список номинаций");
        dispatch("loader/decrement", {}, { root: true });
      }).finally(function () {
        commit("setNominationsLoading", false);
      });
    },
    setNominationByPath: function setNominationByPath(_ref6, path) {
      var commit = _ref6.commit,
          state = _ref6.state;

      var currentNomination = findNominationByPath(state.nominations, path);

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_CURRENT_NOMINATION_SUCCESS */], currentNomination);
    },
    setYearByPath: function setYearByPath(_ref7, path) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var year = findNominationByPath(state.nominations, path);

      commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_CURRENT_NOMINATION_SUCCESS */], year);
    }
  };

  var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["k" /* SET_CURRENT_NOMINATION_SUCCESS */], function (state, value) {
    state.nomination = value || null;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutation_types__["l" /* FETCH_LIST_NOMINATIONS_SUCCESS */], function (state, value) {
    state.nominations = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "path", function path(state, value) {
    state.path = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "setNominationsLoading", function setNominationsLoading(state, value) {
    state.isNominationsLoading = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "setNominationsLoadError", function setNominationsLoadError(state, value) {
    state.nominationsLoadError = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "loadNominees", function loadNominees(state, value) {
    state.nominees = value;
  }), _mutations);

  var getters = {
    nomination: function nomination(_ref8) {
      var nomination = _ref8.nomination;

      return nomination;
    },
    nominations: function nominations(_ref9) {
      var _ref9$nominations = _ref9.nominations,
          nominations = _ref9$nominations === undefined ? [] : _ref9$nominations;

      return nominations.map(function (nomination) {
        return new Nomination(nomination);
      });
    },
    nominees: function nominees(_ref10) {
      var nominees = _ref10.nominees;

      return nominees;
    },
    isNominationsLoading: function isNominationsLoading(_ref11) {
      var isNominationsLoading = _ref11.isNominationsLoading;

      return isNominationsLoading;
    },
    nominationsLoadError: function nominationsLoadError(_ref12) {
      var nominationsLoadError = _ref12.nominationsLoadError;

      return nominationsLoadError;
    }
  };

  return {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
  };
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PROPOSE_NOMINEE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return VOTE_NOMINEE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return VOTED_NOMINATIONS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return NEWS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SUBSCRIBE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UNSUBSCRIBE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return NOMINATION_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return NOMINEES_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return WINNERS_RUBRICS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return WINNERS_NOMINEES_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PHASES_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SUBSCRIBER_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PARTNERS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return USER_INFO_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SIGN_IN_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SIGN_OUT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return AUTHORIZATION_LINKS_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HOW_IT_WAS_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ABOUT_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ABOUT_MAIN_TOP_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ABOUT_MAIN_BOTTOM_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ABOUT_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return AFTER_SUBMIT_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DOCUMENTS_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PARTNERS_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MEMBERS_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MEMBERS_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ACTION_BUTTON_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SHORT_LIST_MESSAGE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BEFORE_AUTH_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VOTES_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DOCUMENTS_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PARTNERS_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NEWS_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LIVE_TITLE_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return LIVE_HEADER_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LIVE_TOP_TEXT_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LIVE_STREAM_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IMAGES_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_MENU_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FOOTER_MENU_API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ANNOUNCEMENT_RESULT_TEXT_API_URL; });
var PROPOSE_NOMINEE_API_URL = '/v1/participant/';
var VOTE_NOMINEE_API_URL = '/v1/nominant/vote/';
var VOTED_NOMINATIONS_API_URL = '/v1/rubrics/voted/';
var NEWS_API_URL = '/v1/news/';
var SUBSCRIBE_API_URL = '/v1/subscriber/activate';
var UNSUBSCRIBE_API_URL = '/v1/subscriber/deactivate/';
var NOMINATION_API_URL = '/v1/nominants/';
var NOMINEES_API_URL = '/v1/rubrics';
var WINNERS_RUBRICS_API_URL = '/v1/winners/rubrics';
var WINNERS_NOMINEES_API_URL = '/v1/winners/nominants/';
var PHASES_API_URL = '/v1/votingStage';
var SUBSCRIBER_API_URL = '/v1/subscriber';
var PARTNERS_API_URL = '/v1/partners';

var USER_INFO_API_URL = '/v2/user';
var SIGN_IN_API_URL = '/v2/user/signin/';
var SIGN_OUT_API_URL = '/v2/user/signout/';
var AUTHORIZATION_LINKS_API_URL = '/v2/links/authorization';

var HOW_IT_WAS_URL = '/v2/how-it-was';

var ABOUT_TEXT_API_URL = '/v1/page/?name=about';
var ABOUT_MAIN_TOP_TEXT_API_URL = '/v1/page/?name=aboutMainTop';
var ABOUT_MAIN_BOTTOM_TEXT_API_URL = '/v1/page/?name=aboutMainBottom';
var ABOUT_TITLE_API_URL = '/v1/page/?name=aboutTitle';
var AFTER_SUBMIT_TEXT_API_URL = '/v1/page/?name=afterSubmitForm';
var DOCUMENTS_TEXT_API_URL = '/v1/page/?name=documents';
var PARTNERS_TEXT_API_URL = '/v1/page/?name=partnersText';
var MEMBERS_TEXT_API_URL = '/v1/page/?name=members';
var MEMBERS_TITLE_API_URL = '/v1/page/?name=membersTitle';
var ACTION_BUTTON_TEXT_API_URL = '/v1/page/?name=buttonName';
var SHORT_LIST_MESSAGE_API_URL = '/v1/page/?name=shortListMessage';
var BEFORE_AUTH_TEXT_API_URL = '/v1/page/?name=beforeAuthText';
var VOTES_TITLE_API_URL = '/v1/page/?name=votesTitle';
var DOCUMENTS_TITLE_API_URL = '/v1/page/?name=documentsTitle';
var PARTNERS_TITLE_API_URL = '/v1/page/?name=partnersTitle';
var NEWS_TITLE_API_URL = '/v1/page/?name=newsTitle';
var LIVE_TITLE_API_URL = '/v1/page/?name=liveTitle';
var LIVE_HEADER_API_URL = '/v1/page/?name=liveHeader';
var LIVE_TOP_TEXT_API_URL = '/v1/page/?name=liveTopText';
var LIVE_STREAM_API_URL = '/v1/page/?name=liveStream';
var IMAGES_API_URL = '/v2/images';

var HEADER_MENU_API_URL = '/v2/header';
var FOOTER_MENU_API_URL = '/v2/footer';

var ANNOUNCEMENT_RESULT_TEXT_API_URL = '/v1/page/?name=announcementResultsText';

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReCaptchaPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);




var reCaptchaState = {
  initCounter: 0,
  injectScript: false
};

var ReCaptchaElement = function () {
  function ReCaptchaElement(sequence, options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReCaptchaElement);

    this.sequence = -1;
    this.rendered = false;
    this.options = {
      type: 'inline',
      action: 'submit'
    };

    this.sequence = sequence;
    this.options = options;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ReCaptchaElement, [{
    key: 'isRendered',
    value: function isRendered() {
      return this.rendered;
    }
  }, {
    key: 'setRendered',
    value: function setRendered(value) {
      this.rendered = value;
    }
  }, {
    key: 'setReCaptchaId',
    value: function setReCaptchaId(reCaptchaId) {
      this.reCaptchaId = reCaptchaId;
    }
  }, {
    key: 'setToken',
    value: function setToken(token) {}
  }, {
    key: 'setError',
    value: function setError() {}
  }]);

  return ReCaptchaElement;
}();

var EventsReCaptcha = function () {
  function EventsReCaptcha(Vue, options) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EventsReCaptcha);

    this.siteKey = null;
    this.version = 2;
    this.language = null;
    this.items = [];
    this.sequence = 0;
    this.needHideBadge = false;
    this.checkDelay = 300;
    this.checkTimer = null;

    this.configure(options);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EventsReCaptcha, [{
    key: 'configure',
    value: function configure(_ref) {
      var siteKey = _ref.siteKey,
          version = _ref.version,
          language = _ref.language,
          hideBadge = _ref.hideBadge;

      if (!siteKey) {
        console.error('Please set site key for google reCaptcha');
      }

      this.siteKey = siteKey;

      if (version) {
        this.version = version;
      }
      if (language) {
        this.language = language;
      }

      this.needHideBadge = hideBadge === true;
    }
  }, {
    key: 'injectScript',
    value: function injectScript() {
      this.version === 3 ? this.injectScriptV3() : this.injectScriptV2();
    }
  }, {
    key: 'injectScriptV2',
    value: function injectScriptV2() {
      var self = this;
      if (typeof window === 'undefined' || reCaptchaState.injectScript === true) {
        return;
      }
      reCaptchaState.injectScript = true;
      window.onLoadGoogleReCaptcha = function () {
        reCaptchaState.initCounter++;
        self.rendering();
      };
      var recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onLoadGoogleReCaptcha&render=explicit' + (this.language ? '&hl=' + this.language : ''));
      recaptchaScript.setAttribute('async', '');
      recaptchaScript.setAttribute('defer', '');
      (document.head || document.body).appendChild(recaptchaScript);

      if (this.needHideBadge) {
        this.hideBadge();
      }
    }
  }, {
    key: 'injectScriptV3',
    value: function injectScriptV3() {}
  }, {
    key: 'hideBadge',
    value: function hideBadge() {
      var style = document.createElement('style');
      style.innerHTML = '.grecaptcha-badge { visibility: hidden; }';
      (document.head || document.body).appendChild(style);
    }
  }, {
    key: 'startCheck',
    value: function startCheck() {
      if (this.checkTimer) {
        window.clearInterval(this.checkTimer);
      }
      this.checkTimer = window.setInterval(this.rendering.bind(this), this.checkDelay);
    }
  }, {
    key: 'rendering',
    value: function rendering() {
      var _this = this;

      this.items.forEach(function (item) {
        if (item && item.data && !item.data.isRendered()) {
          _this.render(item);
        }
      });
    }
  }, {
    key: 'add',
    value: function add(htmlNode, options) {
      var currentSequence = this.sequence++;
      htmlNode.dataset.reCaptchaSequence = currentSequence.toString();

      var element = new ReCaptchaElement(currentSequence, options);

      this.items[currentSequence] = { htmlNode: htmlNode, wrapper: null, data: element };

      this.attachClickHandler(this.items[currentSequence]);

      if (reCaptchaState.initCounter > 0) {
        this.render(this.items[currentSequence]);
      }
    }
  }, {
    key: 'attachClickHandler',
    value: function attachClickHandler(item) {
      var _this2 = this;

      if (!item || !item.data || item.clickAttached) {
        return;
      }
      item.clickAttached = true;

      var options = item.data.options;

      var runAction = function runAction() {
        try {
          if (typeof options.onBeforeAction === 'function' && !options.onBeforeAction()) {
            return false;
          }
        } catch (e) {
          if (typeof options.onError === 'function') {
            options.onError(e);
          }
          return false;
        }

        var reCaptchaReady = item.data.isRendered() && typeof window !== 'undefined' && window.grecaptcha && typeof window.grecaptcha.execute === 'function';

        try {
          if (reCaptchaReady) {
            _this2.run(item);
          } else {
            if (typeof options.onSuccess === 'function') {
              options.onSuccess({ token: null, action: options.action });
            }
          }
        } catch (e) {
          if (typeof options.onSuccess === 'function') {
            options.onSuccess({ token: null, action: options.action });
          }
        }
        return true;
      };

      if (typeof options.actorSelector === 'undefined') {
        item.htmlNode.addEventListener('click', function (event) {
          event.preventDefault();
          return runAction();
        });
      } else if (options.actorSelector !== null) {
        window.document.querySelectorAll(options.actorSelector).forEach(function (actor) {
          actor.addEventListener('click', function (event) {
            event.preventDefault();
            return runAction();
          });
        });
      }
    }
  }, {
    key: 'remove',
    value: function remove(htmlNode, options) {
      var sequence = void 0;
      if (typeof htmlNode.dataset.reCaptchaSequence === 'undefined') {
        console.info('try remove reCaptcha from,  but not exists reCaptchaSequence in dataset', htmlNode);
        return;
      }
      sequence = parseInt(htmlNode.dataset.reCaptchaSequence);
      if (isNaN(sequence)) {
        console.info('try remove reCaptcha, but reCaptchaSequence[' + htmlNode.dataset.reCaptchaSequence + '] in dataset is no number', htmlNode);
        return;
      }
      if (this.items[sequence]) {
        this.destroy(this.items[sequence]);
      }
      this.items[sequence] = null;
      delete this.items[sequence];
      delete htmlNode.dataset.reCaptchaSequence;
    }
  }, {
    key: 'render',
    value: function render(item) {

      if (typeof window === 'undefined') {
        return;
      }

      if (typeof window.grecaptcha === 'undefined' || !grecaptcha in window) {
        console.error('try render, but not loaded js https://www.google.com/recaptcha/api.js');
        return;
      }

      if (typeof window.grecaptcha.render !== 'function') {
        console.error('try render, but not available window.grecaptcha.render function');
        return;
      }

      if (!item || !item.data) {
        console.error('try render empty item or item.data');
        return;
      }

      var options = item.data.options;

      try {
        var captchaParams = {
          sitekey: this.siteKey
        };
        if (options.badge) captchaParams.badge = options.badge;
        if (options.type) captchaParams.type = options.type;
        if (options.tabIndex) captchaParams.tabindex = options.tabIndex;
        if (typeof options.size === 'undefined') {
          captchaParams.size = 'invisible';
          captchaParams.callback = this.setToken.bind(this, { sequence: item.data.sequence });
        }

        var wrapper = document.createElement('div');
        wrapper.className = 'recaptcha__wrapper';
        wrapper.style.position = 'relative';
        wrapper.style.zIndex = '100';

        var container = null;
        if (typeof options.containerSelector !== 'undefined') {
          container = window.document.querySelector(options.containerSelector);
          if (container) {
            container = container[0];
          }
        }

        if (!container) {
          container = item.htmlNode;
        }

        container.parentNode.insertBefore(wrapper, container.nextSibling);

        var recaptchaId = window.grecaptcha.render(wrapper, captchaParams);
        item.data.setRendered(true);
        item.data.setReCaptchaId(recaptchaId);
      } catch (e) {
        console.error(e);
        if (options && typeof options.onError === 'function') {
          options.onError(e);
        }
      }
    }
  }, {
    key: 'destroy',
    value: function destroy(item) {

      if (typeof window === 'undefined') {
        return;
      }

      if (typeof window.grecaptcha === 'undefined') {
        console.warn('try destroy, but js[https://www.google.com/recaptcha/api.js] not loaded yet');
        return;
      }

      if (!item.data.recaptchaId) {
        console.warn('captcha element has\'t recaptcha id');
        return;
      }
      window.grecaptcha.reset(item.data.recaptchaId);
    }
  }, {
    key: 'setToken',
    value: function setToken(params, token) {
      if (typeof window === 'undefined') {
        return;
      }
      if (typeof params.sequence === 'undefined' || !this.items[params.sequence]) {
        return;
      }
      var options = this.items[params.sequence].data.options;

      try {
        if (typeof this.items[params.sequence] !== 'undefined') {
          window.grecaptcha.reset(this.items[params.sequence].data.recaptchaId);
        }
        if (typeof options.onSuccess === 'function') {
          options.onSuccess({ token: token, action: options.action });
        }
      } catch (e) {
        console.error(e);
        if (typeof options.onError === 'function') {
          options.onError(e);
        }
      }
    }
  }, {
    key: 'run',
    value: function run(item) {
      if (typeof window === 'undefined') {
        return;
      }
      window.grecaptcha.execute(item.data.reCaptchaId);
    }
  }, {
    key: 'manualRun',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(sequence) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof window === 'undefined')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (this.items[sequence]) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                return _context.abrupt('return', window.grecaptcha.execute(this.items[sequence].data.reCaptchaId));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function manualRun(_x) {
        return _ref2.apply(this, arguments);
      }

      return manualRun;
    }()
  }]);

  return EventsReCaptcha;
}();

var ReCaptchaPlugin = {
  install: function install(Vue, options) {
    var reCaptcha = new EventsReCaptcha(Vue, options);
    Vue.prototype.$eventsReCaptcha = reCaptcha;

    Vue.mixin({
      data: function data() {
        return { reCaptchaState: reCaptchaState };
      }
    });
    Vue.directive('re-captcha', {
      bind: function bind(el, binding, vnode, oldVnode) {
        reCaptcha.injectScript();
      },
      inserted: function inserted(el, binding, vnode, oldVnode) {
        reCaptcha.add(el, binding.value);
      },
      unbind: function unbind(el, binding, vnode, oldVnode) {
        reCaptcha.remove(el, binding.value);
      }
    });
  }
};

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resolve__ = __webpack_require__(158);


/* harmony default export */ __webpack_exports__["a"] = (function (regionTID) {

  var createSimpleRoute = function createSimpleRoute(urlPath, component) {
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var route = {
      path: urlPath,
      component: component,
      alias: ['/award' + urlPath]
    };

    if (name) {
      route.name = name;
    }

    return route;
  };

  var createPageComponent = function createPageComponent(pageTID) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__resolve__["b" /* resolvePageComponent */])(regionTID, pageTID);
  };

  var Confirm = function Confirm(resolve) {
    __webpack_require__.e/* require.ensure */(28).then((function () {
      resolve(__webpack_require__(252));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  };

  return [createSimpleRoute('/', createPageComponent('home/Home')), createSimpleRoute('/about/', createPageComponent('about/About')), createSimpleRoute('/members/', createPageComponent('members/Members')), createSimpleRoute('/news/', createPageComponent('news/News')), createSimpleRoute('/votes/', createPageComponent('votes/Votes')), createSimpleRoute('/votes/:year(\\d{4})/', createPageComponent('archive/Archive'), 'archive-votes'), createSimpleRoute('/votes/:rubric/', createPageComponent('votesForm/VotesForm')), createSimpleRoute('/partners/', createPageComponent('partners/Partners')), createSimpleRoute('/live/', createPageComponent('live/Live')), createSimpleRoute('/docs/', createPageComponent('docs/Docs')), createSimpleRoute('/votes/:rubric/:year(\\d{4})/', createPageComponent('archiveWinners/ArchiveWinners'), 'archive-rubric-votes'), createSimpleRoute('/kontur/', createPageComponent('kontur/Kontur')), createSimpleRoute('/404/', createPageComponent('notFound/NotFound')), createSimpleRoute('/confirm/', Confirm, 'activate'), createSimpleRoute('/unsubscribe/', Confirm, 'deactivate'), { path: '*', redirect: '/404/' }];
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YandexCounterService", function() { return YandexCounterService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_inject__);








var YANDEX_COUNTERS = {
  54: [1337757],
  59: [6775807],
  63: [12725662],
  29: [12725860],
  66: [6874273],
  24: [1124739],
  72: [12725777],
  74: [6596923],
  75: [21438901]
};

var REACH_GOALS_PAGE_TYPES = {
  '/': { default: 'Главная' },
  '/about/': { default: 'О премии' },
  '/partners/': { default: 'Партнеры' },
  '/news/': { default: 'Новости' },
  '/members/': { default: 'Участникам' },
  '/docs/': { default: 'Положение' },
  '/live/': { default: 'Награждение' },
  '/404/': { default: '404' },
  '/votes/': function votes(pathParts) {
    var lastPathPart = pathParts.length > 0 ? pathParts.pop() : '';
    if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default()(parseInt(lastPathPart, 10))) {
      return 'Победители';
    }
    return 'Номинации_Голосование_Победители';
  }
};

var REACH_GOALS = {
  partnersBlocks: {
    userObserve: {
      default: {
        name: 'viewPartnersBlockPeoplesAward',
        props: '{"%Сущность%": {"%Тип страницы%": {"Партнеры премии (блок)": {"Просмотр": ' + '{"undefined": "%Номер блока%"}}}}}'
      }
    },

    itemClick: {
      default: {
        name: 'clickPartnersBlockPeoplesAward',
        props: '{"%Сущность%": {"%Тип страницы%": {"Партнеры премии (блок)": {"Клик": ' + '{"undefined": {"%Номер блока%": "%Название партнера%"}}}}}}'
      }
    },
    defaultParams: {
      '%Сущность%': 'Народная премия',
      '%Тип страницы%': '',
      '%Номер блока%': '',
      '%Название партнера%': ''
    }
  }
};

var YandexCounterService = function () {
  function YandexCounterService() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, YandexCounterService);

    this._isInits = {};
    this._q = [];
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(YandexCounterService, [{
    key: 'sendReachGoal',
    value: function sendReachGoal(regionId, pageType, blockType, fieldType, valueName, goalName) {
      var _this = this;

      var fieldName = {};
      fieldName[fieldType] = valueName;

      var blockValue = {};
      blockValue[blockType] = fieldName;

      var currentPageType = pageType;

      var clickPageType = {};
      clickPageType[currentPageType] = blockValue;

      var params = {
        'Народная премия': clickPageType
      };

      var newCountersIds = YANDEX_COUNTERS[regionId];
      if (newCountersIds !== undefined && newCountersIds.length > 0) {
        newCountersIds.forEach(function (counterId) {
          _this._sendReachGoal(counterId, goalName, params);
        });
      }
    }
  }, {
    key: 'sendReachGoalWithoutPage',
    value: function sendReachGoalWithoutPage(regionId, blockType, fieldType, valueName, goalName) {
      var _this2 = this;

      var fieldName = {};
      fieldName[fieldType] = valueName;

      var blockValue = {};
      blockValue[blockType] = fieldName;

      var params = {
        'Народная премия': blockValue
      };

      var newCountersIds = YANDEX_COUNTERS[regionId];
      if (newCountersIds !== undefined && newCountersIds.length > 0) {
        newCountersIds.forEach(function (counterId) {
          _this2._sendReachGoal(counterId, goalName, params);
        });
      }
    }
  }, {
    key: '_initCounter',
    value: function _initCounter(counterId) {
      var _this3 = this;

      if (typeof this._isInits[counterId] !== 'undefined') {
        return;
      }
      this._isInits[counterId] = counterId;
      console.info('Init ym counter ' + counterId);

      var applyOnLoading = function applyOnLoading() {
        ym(counterId, 'init', {
          ssr: true,
          clickmap: true,
          accurateTrackBounce: true,
          trackLinks: true
        });
        _this3._q = _this3._q.filter(function (params) {
          if (params[0] === counterId) {
            ym.apply(undefined, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(params));
            return false;
          }
          return true;
        });
      };

      var applyOnError = function applyOnError() {
        _this3._isInits[counterId] = undefined;
        delete _this3._isInits[counterId];
        console.error('Error loading the script counter ' + counterId + '!');
      };

      (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () {
          (m[i].a = m[i].a || []).push(arguments);
        };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
          if (document.scripts[j].src === r) {
            return;
          }
        }
        k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a);
        k.onload = function () {
          return applyOnLoading();
        };
        k.onerror = function () {
          return applyOnError();
        };
      })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js?id=' + counterId, 'ym');
    }
  }, {
    key: '_sendReachGoal',
    value: function _sendReachGoal(counterId, goalName, params) {
      if (typeof window['yaCounter' + counterId] === 'undefined') {
        this._initCounter(counterId);
      }

      if (typeof window['yaCounter' + counterId] !== 'undefined' && 'reachGoal' in window['yaCounter' + counterId]) {
        window['yaCounter' + counterId].reachGoal(goalName, params);
      } else if (typeof ym !== 'undefined') {
        ym(counterId, 'reachGoal', goalName, params);
      } else {
        this._q.push([counterId, 'reachGoal', goalName, params]);
      }
    }
  }, {
    key: '_preparePageType',
    value: function _preparePageType() {
      if (!document.location) {
        return undefined;
      }

      var path = document.location.pathname.replace('/award/', '/');
      var pathParts = path.split('/').filter(function (p) {
        return p !== '';
      });
      var firstPathPart = pathParts[0] ? '/' + pathParts.shift() + '/' : '/';
      if (REACH_GOALS_PAGE_TYPES[firstPathPart]) {
        var pageTypes = REACH_GOALS_PAGE_TYPES[firstPathPart];
        if (typeof pageTypes === 'function') {
          return pageTypes(pathParts);
        }
        return pageTypes.default;
      }

      return undefined;
    }
  }, {
    key: 'sendBlockReachGoal',
    value: function sendBlockReachGoal(reachBlockTid, reachGoalTid, replaceParams) {
      var _this4 = this;

      if (typeof window['CONTEXT_REGION'] === 'undefined' || !window['CONTEXT_REGION'] || typeof YANDEX_COUNTERS[window.CONTEXT_REGION] === 'undefined') {
        console.warn('region is not defined when reach goal TID: [' + reachGoalTid + ']');
        return;
      }

      var regionId = window['CONTEXT_REGION'];

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(REACH_GOALS[reachBlockTid]) !== 'object' || !REACH_GOALS[reachBlockTid] || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(REACH_GOALS[reachBlockTid][reachGoalTid]) !== 'object' || !REACH_GOALS[reachBlockTid][reachGoalTid]) {
        console.warn('reach goal TID not exists: [' + reachGoalTid + ']');
        return;
      }

      var reachGoal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(REACH_GOALS[reachBlockTid][reachGoalTid][regionId]) === 'object' && REACH_GOALS[reachBlockTid][reachGoalTid][regionId] ? REACH_GOALS[reachBlockTid][reachGoalTid][regionId] : REACH_GOALS[reachBlockTid][reachGoalTid]['default'];

      if ((typeof reachGoal === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(reachGoal)) !== 'object' || !reachGoal || !reachGoal.name) {
        console.warn('reach goal not exists when TID: [' + reachGoalTid + ']');
        return;
      }

      var replaces = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, REACH_GOALS[reachBlockTid].defaultParams ? REACH_GOALS[reachBlockTid].defaultParams : {}, replaceParams, {
        '%Тип страницы%': this._preparePageType()
      });

      var strParams = reachGoal.props ? reachGoal.props : '';
      for (var key in replaces) {
        if (typeof replaces[key] === 'undefined') {
          continue;
        }
        strParams = strParams.replaceAll(key, replaces[key]);
      }

      var params = {};
      try {
        params = JSON.parse(strParams);
      } catch (e) {
        console.error(e);
      }

      var newCountersIds = YANDEX_COUNTERS[regionId];
      if (newCountersIds !== undefined && newCountersIds.length > 0) {
        newCountersIds.forEach(function (counterId) {
          _this4._sendReachGoal(counterId, reachGoal.name, params);
        });
      }
    }
  }, {
    key: 'sendPartnerBlockReachGoal',
    value: function sendPartnerBlockReachGoal(reachGoalTid, params) {
      this.sendBlockReachGoal('partnersBlocks', reachGoalTid, params);
    }
  }]);

  return YandexCounterService;
}();

__WEBPACK_IMPORTED_MODULE_6_vue_inject___default.a.service('yandexCounterService', YandexCounterService);

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observer__ = __webpack_require__(275);





var defaultTreshhold = [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1];
var observers = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind($el, _ref) {
    var _this = this;

    var value = _ref.value,
        once = _ref.modifiers.once;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var options, observer, callbacks;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (value) {
                _context.next = 2;
                break;
              }

              throw new Error('[v-intersect]: Intersection callback or observer options not provided.');

            case 2:
              options = typeof value === 'function' ? {} : value;
              observer = new __WEBPACK_IMPORTED_MODULE_3__observer__["a" /* default */]({
                threshold: options.threshold ? options.threshold : defaultTreshhold,
                rootMargin: options.rootMargin
              });


              observers.set($el, observer);

              callbacks = {
                onIntersection: function onIntersection(entry) {
                  if (once === true) {
                    observer.remove($el);
                  }
                  if (typeof value === 'function') {
                    value(entry);
                    return;
                  }
                  if (typeof options.onIntersection === 'function') {
                    options.onIntersection(entry);
                  }
                }
              };


              if (typeof options.onOutIntersection === 'function') {
                callbacks.onOutIntersection = function (entry) {
                  if (options.onOutIntersection) {
                    options.onOutIntersection(entry);
                  }
                };
              }
              observer.add($el, callbacks);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  unbind: function unbind($el) {
    if (observers.has($el)) {
      observers.get($el).remove($el);
      observers.delete($el);
    }
  }
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_urls__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_store__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_user__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_context__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_phases__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_news__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_nominations__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_archive__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_subscribes__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_texts__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_vote__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_loader__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_partners__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_titles__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_about__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_adv__ = __webpack_require__(277);
























__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

function store() {
  var state = {
    path: null,
    myNominee: typeof localStorage !== 'undefined' ? localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__constants_store__["a" /* MY_NOMINEE_STORE_NAME */]) || null : null,
    visitedPaths: [],
    isMain: false,
    isMobile: false,
    loading: true,
    headerMenu: [],
    footerMenu: [],
    footerInfo: [],
    socialLinks: [],
    styling: {
      backgroundImage: '',
      defaultShareImage: '',
      footerBackgroundColor: '',
      headerBackgroundColor: '',
      imageBackgroundColorOpacity: 0,
      logotypeLightImage: '',
      logotypeDarkImage: '',
      subscriptionBackgroundImage: '',
      linkAndMenuLinkUnderlineColor: '',
      footerTextAndFooterHeaderMenuLinkColor: '',
      footerBlockHeaderColor: ''
    }
  };

  var actions = {
    setPath: function setPath(_ref, path) {
      var commit = _ref.commit;

      commit('path', path);

      if (path === '/') {
        commit('isMain', true);
      } else {
        commit('isMain', false);
      }

      if (!state.visitedPaths.find(function (visited) {
        return visited === path;
      })) {
        commit('visitedPaths', path);
      }
    },
    setMyNominee: function setMyNominee(_ref2, myNominee) {
      var commit = _ref2.commit;

      commit('myNominee', myNominee);
    },
    setIsMobile: function setIsMobile(_ref3, isMobile) {
      var commit = _ref3.commit;

      if (typeof isMobile === 'boolean') {
        commit('isMobile', isMobile);
      }
    },
    fetchHeaderMenu: function fetchHeaderMenu(_ref4) {
      var _this = this;

      var commit = _ref4.commit,
          getters = _ref4.getters;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = getters['context/contextHost'] + __WEBPACK_IMPORTED_MODULE_5__constants_urls__["a" /* HEADER_MENU_API_URL */];
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                  withCredentials: true,
                  method: 'GET',
                  url: url
                });

              case 4:
                res = _context.sent;


                commit('headerMenu', res.data.data.menuLinks);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    fetchFooterMenu: function fetchFooterMenu(_ref5) {
      var _this2 = this;

      var commit = _ref5.commit,
          getters = _ref5.getters;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var url, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = getters['context/contextHost'] + __WEBPACK_IMPORTED_MODULE_5__constants_urls__["b" /* FOOTER_MENU_API_URL */];
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                  withCredentials: true,
                  method: 'GET',
                  url: url
                });

              case 4:
                res = _context2.sent;


                commit('footerMenu', res.data.data.menuLinks);
                commit('footerInfo', res.data.data.informationBlock);
                commit('socialLinks', res.data.data.socialLinks);
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](1);

                console.error(_context2.t0);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 10]]);
      }))();
    },
    fetchStyling: function fetchStyling(_ref6) {
      var _this3 = this;

      var commit = _ref6.commit,
          getters = _ref6.getters;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var url, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = getters['context/contextHost'] + __WEBPACK_IMPORTED_MODULE_5__constants_urls__["c" /* IMAGES_API_URL */];
                _context3.prev = 1;
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default()({
                  withCredentials: true,
                  method: 'GET',
                  url: url
                });

              case 4:
                res = _context3.sent;

                commit('styling', res.data.data);
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                console.error(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8]]);
      }))();
    },
    setLoading: function setLoading(_ref7, params) {
      var commit = _ref7.commit;

      var link = params.link;
      var value = params.action;

      if (state.visitedPaths.find(function (visited) {
        return visited === link;
      })) {
        window.scrollTo(0, 0);
        commit('loading', false);
        return false;
      }

      commit('loading', value);
      return true;
    }
  };

  var mutations = {
    path: function path(state, _path) {
      state.path = _path;
    },
    myNominee: function myNominee(state, value) {
      state.myNominee = value;

      if (value) {
        localStorage.setItem(__WEBPACK_IMPORTED_MODULE_6__constants_store__["a" /* MY_NOMINEE_STORE_NAME */], value);
      } else {
        localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_6__constants_store__["a" /* MY_NOMINEE_STORE_NAME */]);
      }
    },
    visitedPaths: function visitedPaths(state, value) {
      state.visitedPaths.push(value);
    },
    isMain: function isMain(state, value) {
      state.isMain = value;
    },
    isMobile: function isMobile(state, value) {
      state.isMobile = value;
    },
    headerMenu: function headerMenu(state, value) {
      state.headerMenu = value;
    },
    footerMenu: function footerMenu(state, value) {
      state.footerMenu = value;
    },
    footerInfo: function footerInfo(state, value) {
      state.footerInfo = value;
    },
    socialLinks: function socialLinks(state, value) {
      state.socialLinks = value;
    },
    styling: function styling(state, value) {
      state.styling = value;
    },
    loading: function loading(state, value) {
      state.loading = value;
    }
  };

  var getters = {
    path: function path(_ref8) {
      var path = _ref8.path;

      return path;
    },
    myNominee: function myNominee(_ref9) {
      var myNominee = _ref9.myNominee;

      return myNominee;
    },
    isMain: function isMain(_ref10) {
      var isMain = _ref10.isMain;

      return isMain;
    },
    isMobile: function isMobile(_ref11) {
      var isMobile = _ref11.isMobile;

      return isMobile;
    },
    loading: function loading(_ref12) {
      var loading = _ref12.loading;

      return loading;
    },
    headerMenu: function headerMenu(_ref13) {
      var headerMenu = _ref13.headerMenu;

      return headerMenu;
    },
    footerMenu: function footerMenu(_ref14) {
      var footerMenu = _ref14.footerMenu;

      return footerMenu;
    },
    footerInfo: function footerInfo(_ref15) {
      var footerInfo = _ref15.footerInfo;

      return footerInfo;
    },
    socialLinks: function socialLinks(_ref16) {
      var socialLinks = _ref16.socialLinks;

      return socialLinks;
    },
    mainImage: function mainImage(_ref17) {
      var styling = _ref17.styling;

      return styling.backgroundImage;
    },
    mainImageOpacity: function mainImageOpacity(_ref18) {
      var styling = _ref18.styling;

      return styling.imageBackgroundColorOpacity;
    },
    headerBackgroundColor: function headerBackgroundColor(_ref19) {
      var styling = _ref19.styling;

      return styling.headerBackgroundColor;
    },
    footerBackgroundColor: function footerBackgroundColor(_ref20) {
      var styling = _ref20.styling;

      return styling.footerBackgroundColor;
    },
    defaultShareImage: function defaultShareImage(_ref21) {
      var styling = _ref21.styling;

      return styling.defaultShareImage;
    },
    logotypeLightImage: function logotypeLightImage(_ref22) {
      var styling = _ref22.styling;

      return styling.logotypeLightImage;
    },
    logotypeDarkImage: function logotypeDarkImage(_ref23) {
      var styling = _ref23.styling;

      return styling.logotypeDarkImage;
    },
    linkColor: function linkColor(_ref24) {
      var styling = _ref24.styling;

      return styling.linkAndMenuLinkUnderlineColor;
    },
    subscriptionBackgroundImage: function subscriptionBackgroundImage(_ref25) {
      var styling = _ref25.styling;

      return styling.subscriptionBackgroundImage;
    },
    menuLinkColor: function menuLinkColor(_ref26) {
      var styling = _ref26.styling;

      return styling.footerTextAndFooterHeaderMenuLinkColor;
    },
    footerHeadingsColor: function footerHeadingsColor(_ref27) {
      var styling = _ref27.styling;

      return styling.footerBlockHeaderColor;
    },
    headingsColor: function headingsColor(_ref28) {
      var styling = _ref28.styling;

      return styling.pageAndBlockHeaderColor;
    }
  };

  return {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters,
    modules: {
      nominationPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__modules_nominations__["a" /* default */])(),
      archivePage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__modules_archive__["a" /* default */])(),
      phaseBlock: __WEBPACK_IMPORTED_MODULE_9__modules_phases__["a" /* default */],
      news: __WEBPACK_IMPORTED_MODULE_10__modules_news__["a" /* default */],
      subscribesBlock: __WEBPACK_IMPORTED_MODULE_13__modules_subscribes__["a" /* default */],
      user: __WEBPACK_IMPORTED_MODULE_7__modules_user__["a" /* default */],
      context: __WEBPACK_IMPORTED_MODULE_8__modules_context__["a" /* default */],
      vote: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__modules_vote__["a" /* default */])(),
      loader: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__modules_loader__["a" /* default */])(),
      texts: __WEBPACK_IMPORTED_MODULE_14__modules_texts__["a" /* default */],
      partners: __WEBPACK_IMPORTED_MODULE_17__modules_partners__["a" /* default */],
      titles: __WEBPACK_IMPORTED_MODULE_18__modules_titles__["a" /* default */],
      about: __WEBPACK_IMPORTED_MODULE_19__modules_about__["a" /* default */],
      adv: __WEBPACK_IMPORTED_MODULE_20__modules_adv__["a" /* default */]
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store(store()));

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearNameFromLeadingTrailingQuotes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return plural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ucFirst; });
var clearNameFromLeadingTrailingQuotes = function clearNameFromLeadingTrailingQuotes(str) {
  var name = str.trim();
  if (name.indexOf('«') === 0) {
    name = name.substring(1);
    if (name.indexOf('»') === name.length - 1) {
      name = name.substring(0, name.length - 1);
    }
  }

  if (name.indexOf('&laquo;') === 0) {
    name = name.substring(7);
    if (name.indexOf('&raquo;') === name.length - 7) {
      name = name.substring(0, name.length - 7);
    }
  }
  return name;
};

var plural = function plural(count, words) {
  if (words.length !== 3) {
    throw new Error('Массив words должен содержать 3 формы слова');
  }

  var mod100 = Math.abs(count) % 100;
  var mod10 = mod100 % 10;

  if (mod100 > 10 && mod100 < 20) return words[2];
  if (mod10 > 1 && mod10 < 5) return words[1];
  if (mod10 === 1) return words[0];
  return words[2];
};

var ucFirst = function ucFirst(str) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PageContextForNews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewsItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze__);




var PageContextForNews = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_freeze___default()({
  NEWS: 'news',
  MAIN: 'main'
});

var NewsItem = function () {
  function NewsItem(data) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NewsItem);

    this.data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NewsItem, [{
    key: 'getDate',
    value: function getDate() {
      return this.data.datetime;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.data.title;
    }
  }, {
    key: 'getText',
    value: function getText() {
      return this.data.announce;
    }
  }, {
    key: 'getLink',
    value: function getLink() {
      return this.data.link;
    }
  }]);

  return NewsItem;
}();

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MY_NOMINEE_STORE_NAME; });
var MY_NOMINEE_STORE_NAME = 'my-nominee';

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_intersect_intersect__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_inject__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_inject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_inject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_youtube__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portal_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_ReCaptcha_ReCaptchaPlugin__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resolve__ = __webpack_require__(158);
















__webpack_require__(230);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_inject___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_youtube___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].directive('intersect', __WEBPACK_IMPORTED_MODULE_7__shared_intersect_intersect__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12__plugins_ReCaptcha_ReCaptchaPlugin__["a" /* ReCaptchaPlugin */], { siteKey: '6LeqU9IrAAAAADk1aPkcdA3ybceEIt7U5hTO57Rj', version: 2, hideBadge: false });

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  routes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__routes__["a" /* default */])(window.CONTEXT_REGION),
  mode: 'history',
  base: '/award/',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.devtools = true;

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  components: { App: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__resolve__["a" /* resolveAppComponent */])(window.CONTEXT_REGION) },
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  router: router
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(20);





var VoteServices = function () {
  function VoteServices() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, VoteServices);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(VoteServices, null, [{
    key: 'proposeNominee',
    value: function proposeNominee(params) {
      var host = params.host;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        withCredentials: true,
        method: 'post',
        url: host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["A" /* PROPOSE_NOMINEE_API_URL */],
        data: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (result) {
        return result.data.status === 200;
      }).catch(function (error) {
        console.error(error);
        throw error;
      });
    }
  }, {
    key: 'fetchNominationsVoted',
    value: function fetchNominationsVoted(params) {
      var host = params.host;
      var voter = '';

      if (params && params.voter) {
        voter = params.voter;
      }

      var query = {
        voter: voter
      };

      var url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["B" /* VOTED_NOMINATIONS_API_URL */];
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        withCredentials: true,
        method: 'GET',
        url: url,
        params: query
      }).then(function (result) {
        var arrayNominations = result.data;
        var resultArray = [];

        if (arrayNominations.length === 0) {
          return [];
        }

        for (var i = 0; i < arrayNominations.length; i += 1) {
          resultArray[i] = {
            name: arrayNominations[i].originName,
            nominationId: Number(arrayNominations[i].rubricId),
            id: Number(arrayNominations[i].id),
            isRevoteAllowed: arrayNominations[i].isRevoteAllowed
          };
        }

        return resultArray;
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'voteNominee',
    value: function voteNominee(params) {
      var host = params.host;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        withCredentials: true,
        method: 'post',
        url: host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["C" /* VOTE_NOMINEE_API_URL */],
        data: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (result) {
        if (result.data.status === 200) {
          var region = params.region;
          var goalsName = {
            66: 'AW2018VOTE',
            54: 'AW2019VOTE'
          };

          var eventCategory = {
            66: 'E1award2018',
            54: 'NGSaward2019'
          };

          if (typeof yaCounter6874273 !== 'undefined' && region == 66) {
            yaCounter6874273.reachGoal(goalsName[region]);
          }

          if (typeof yaCounter1337757 !== 'undefined' && region == 54) {
            yaCounter1337757.reachGoal(goalsName[region]);
          }

          if (typeof ga !== 'undefined') {
            ga('send', {
              hitType: 'event',
              eventCategory: eventCategory[region],
              eventAction: goalsName[region]
            });
          }
        }
        return result;
      }).catch(function (error) {
        console.error(error);

        if (error.response) {
          return error.response;
        }
      });
    }
  }]);

  return VoteServices;
}();

/* harmony default export */ __webpack_exports__["a"] = (VoteServices);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAdsConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var SCROOGE_API = 'https://ngs.ru/ump-api/service-scrooge/graphql';
var query = '\nfragment adunit on Adunit {\n    id\n    projectKey\n    adserver\n    placement\n    layout\n    placeholderEnabled\n    placeholderConfig {\n        height\n        backgroundEnabled\n        bordersEnabled\n        advMarkEnabled\n        advMarkInnerEnabled\n    }\n    refreshEnabled\n    refreshConfig {\n        refreshInterval\n        viewportTime\n    }\n    adfoxConfig {\n        p1\n        p2\n    }\n    rtbConfig {\n        id\n    }\n    gptConfig {\n        adUnitPath\n        sizes {\n            sizes0x0\n            sizes336x0\n        }\n    }\n    scroogeConfig {\n        fill\n    }\n    biddersConfig {\n        codeType\n        sizes\n    },\n    advInfoPosition\n}\n\nquery getAdsConfig($filter: AdsConfigFilterInput!) {\n    result: adsConfig(filter: $filter) {\n        __typename\n        ...on AdsConfig {\n            adunits {\n                ...adunit\n            }\n            bidders {\n                id\n                key\n                adserver\n                adserverBidderId\n                params {\n                    key\n                    type\n                }\n            }\n            adunitsBidders {\n                id\n                placement\n                params {\n                    key\n                    value\n                }\n            }\n        }\n        ...on ProblemInterface {\n            message\n        }\n    }\n}\n';

var getAdsConfig = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(variables) {
        var data, _ref2, response, config;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        data = { variables: variables, query: query };
                        _context.next = 3;
                        return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(SCROOGE_API, data, {
                            headers: { 'Content-Type': 'application/json' }
                        });

                    case 3:
                        _ref2 = _context.sent;
                        response = _ref2.data;

                        if (response.data.result) {
                            _context.next = 9;
                            break;
                        }

                        if (!(response.errors.length > 0)) {
                            _context.next = 8;
                            break;
                        }

                        throw new Error(response.errors[0].message);

                    case 8:
                        throw new Error('[CreativeManager]: \u043A\u043E\u043D\u0444\u0438\u0433 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response));

                    case 9:
                        config = response.data.result;

                        config.layout = 'STANDART';

                        return _context.abrupt('return', config);

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getAdsConfig(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Observer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);





var Observer = function () {
  function Observer(_ref) {
    var _ref$root = _ref.root,
        root = _ref$root === undefined ? null : _ref$root,
        _ref$rootMargin = _ref.rootMargin,
        rootMargin = _ref$rootMargin === undefined ? '0px 0px 0px 0px' : _ref$rootMargin,
        _ref$threshold = _ref.threshold,
        threshold = _ref$threshold === undefined ? 0 : _ref$threshold,
        _ref$Observer = _ref.Observer,
        _Observer = _ref$Observer === undefined ? IntersectionObserver : _ref$Observer;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Observer);

    this.entries = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
    this.destroyed = false;
    this.currentRoot = null;

    this.currentRoot = root;
    this.currentRootMargin = rootMargin;
    this.currentThreshold = threshold;
    this.Observer = _Observer;
    this.observer = this.recreateObserver();
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Observer, [{
    key: 'add',
    value: function add(entry, callbacks) {
      this.checkStatus('add');

      if (this.entries) {
        this.entries.set(entry, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, callbacks, { wasIntersecting: null }));
      }

      this.observer.observe(entry);
    }
  }, {
    key: 'remove',
    value: function remove(entry) {
      this.checkStatus('remove');
      var hasEntry = this.entries && this.entries.has(entry) ? true : false;
      if (hasEntry) {
        this.entries.delete(entry);
        this.observer.unobserve(entry);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.checkStatus('destroy');
      delete this.entries;
      this.observer.disconnect();
      this.destroyed = true;
    }
  }, {
    key: 'recreateObserver',
    value: function recreateObserver() {
      var _this = this;

      if (this.observer) {
        this.observer.disconnect();
      }

      var observer = new this.Observer(this.observerCallback.bind(this), {
        threshold: this.threshold,
        root: this.root,
        rootMargin: this.rootMargin
      });

      if (this.entries) {
        this.entries.forEach(function (_, element) {
          _this.observer.observe(element);
        });
      }

      return observer;
    }
  }, {
    key: 'observerCallback',
    value: function observerCallback(entries) {
      var _this2 = this;

      entries.forEach(function (entry) {
        var target = _this2.entries && _this2.entries.get(entry.target);
        if (entry.isIntersecting === target.wasIntersecting) {
          return;
        }

        if (entry.isIntersecting && 'onIntersection' in target) {
          target.onIntersection(entry);
        } else if (!entry.isIntersecting && 'onOutIntersection' in target) {
          target.onOutIntersection(entry);
        }

        if (_this2.entries) {
          _this2.entries.set(entry.target, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target, { wasIntersecting: entry.isIntersecting }));
        }
      });
    }
  }, {
    key: 'checkStatus',
    value: function checkStatus(methodName) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'method';

      if (this.destroyed) {
        var message = 'Observer был уничтожен до вызова ';

        switch (type) {
          case 'method':
            message += 'метода';
            break;
          case 'setter':
            message += 'сеттера';
            break;
          case 'getter':
            message += 'геттера';
            break;
        }

        throw new Error(message + ' "' + methodName + '"');
      }
    }
  }, {
    key: 'root',
    get: function get() {
      this.checkStatus('root', 'getter');
      return this.currentRoot;
    },
    set: function set(val) {
      this.checkStatus('root', 'setter');
      if (val === this.currentRoot) {
        return;
      }
      this.currentRoot = val;
      this.observer = this.recreateObserver();
    }
  }, {
    key: 'rootMargin',
    get: function get() {
      this.checkStatus('rootMargin', 'getter');
      return this.currentRootMargin;
    },
    set: function set(val) {
      this.checkStatus('rootMargin', 'setter');
      if (val === this.currentRootMargin) {
        return;
      }
      this.currentRootMargin = val;
      this.observer = this.recreateObserver();
    }
  }, {
    key: 'threshold',
    get: function get() {
      this.checkStatus('threshold', 'getter');
      return this.currentThreshold;
    },
    set: function set(val) {
      this.checkStatus('threshold', 'setter');
      if (val === this.currentThreshold) {
        return;
      }
      this.currentThreshold = val;
      this.observer = this.recreateObserver();
    }
  }]);

  return Observer;
}();




/* harmony default export */ __webpack_exports__["a"] = (Observer);

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);



var state = {
    howItWas: null
};

var actions = {
    getHowItWasBlock: function getHowItWasBlock(_ref) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["d" /* HOW_IT_WAS_URL */], { withCredentials: true }).then(function (result) {
            var howItWas = result.data.data;

            if (howItWas) {
                commit('howItWas', result.data.data);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
};

var getVideoIdYt = function getVideoIdYt(url) {
    var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    return url.match(p) ? RegExp.$1 : null;
};

var getVideoIdVk = function getVideoIdVk(url) {
    var p = /^(?:https?:\/\/)?(?:www\.)?(?:vk\.com|vk\.ru|vkvideo\.ru)\/(?:video(-?\d+)_(\d+))?$/;
    return url.match(p) ? { 'oid': RegExp.$1, 'id': RegExp.$2 } : null;
};

var mutations = {
    howItWas: function howItWas(state, value) {
        state.howItWas = value;
        var videoUrl = value.videoUrl;
        state.howItWas.videoIdYt = getVideoIdYt(videoUrl);
        state.howItWas.videoIdVk = getVideoIdVk(videoUrl);
    }
};

var getters = {
    howItWas: function howItWas(_ref2) {
        var howItWas = _ref2.howItWas;

        return howItWas;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_getAdsConfig__ = __webpack_require__(274);






var state = {
    scroogeConfig: null
};

var actions = {
    getScroogeConfig: function getScroogeConfig(_ref, params) {
        var _this = this;

        var commit = _ref.commit;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var filter, config;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            filter = { projectKey: params.projectKey, isMobile: params.isMobile };
                            _context.prev = 1;
                            _context.next = 4;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__services_getAdsConfig__["a" /* getAdsConfig */])({ filter: filter });

                        case 4:
                            config = _context.sent;

                            commit('scroogeConfig', config);
                            return _context.abrupt('return', config);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            console.warn(_context.t0);
                            console.warn('[CreativeManager]: ошибка получения конфига', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ filter: filter }));

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this, [[1, 9]]);
        }))();
    }
};

var mutations = {
    scroogeConfig: function scroogeConfig(state, value) {
        state.scroogeConfig = value;
    }
};

var getters = {
    scroogeConfig: function scroogeConfig(_ref2) {
        var scroogeConfig = _ref2.scroogeConfig;

        return scroogeConfig;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nominations__ = __webpack_require__(170);






/* harmony default export */ __webpack_exports__["a"] = (function () {
  var _mutations;

  var state = {
    nomination: null,
    nominations: [],
    nominees: [],
    path: null
  };

  var actions = {
    setCurrentPath: function setCurrentPath(_ref, path) {
      var commit = _ref.commit;

      commit("path", path);
    },
    setNomination: function setNomination(_ref2, nomination) {
      var commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS */], nomination);
    },
    loadNominees: function loadNominees(_ref3, params) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          state = _ref3.state;

      var host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      var url = "" + (host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["M" /* WINNERS_NOMINEES_API_URL */]) + state.nomination.id + "/";

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, { withCredentials: true }).then(function (result) {
        commit("loadNominees", result.data);

        dispatch("loader/decrement", {}, { root: true });
      }).catch(function (error) {
        console.log(error);
        dispatch("loader/decrement", {}, { root: true });
      });
    },
    loadNominations: function loadNominations(_ref4, params) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch,
          state = _ref4.state;

      var host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      var currentYear = "";

      if (params && params.year) {
        currentYear = "?year=" + params.year;
      }

      var url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["N" /* WINNERS_RUBRICS_API_URL */] + currentYear;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, { withCredentials: true }).then(function (_ref5) {
        var nominations = _ref5.data;

        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS */], nominations);

        if (state.path !== null) {
          var currentNomination = nominations.find(function (nomination) {
            if (state.path.indexOf(nomination.link) !== -1) {
              return nomination;
            }

            return undefined;
          });

          commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS */], currentNomination);
        }

        dispatch("loader/decrement", {}, { root: true });
      }).catch(function (error) {
        console.log(error);
        dispatch("loader/decrement", {}, { root: true });
      });
    },
    setNominationByPath: function setNominationByPath(_ref6, path) {
      var commit = _ref6.commit,
          state = _ref6.state;

      var currentNomination = state.nominations.find(function (nomination) {
        if (path.indexOf(nomination.link) !== -1) {
          return nomination;
        }

        return undefined;
      });

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS */], currentNomination);
    },
    setYearByPath: function setYearByPath(_ref7, path) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var year = state.nominations.find(function (nomination) {
        if (path.indexOf(nomination.link) !== -1) {
          return nomination;
        }

        return undefined;
      });

      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS */], year);
    }
  };

  var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS */], function (state, value) {
    state.nomination = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["j" /* FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS */], function (state, value) {
    state.nominations = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "path", function path(state, value) {
    state.path = value;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, "loadNominees", function loadNominees(state, value) {
    state.nominees = value;
  }), _mutations);

  var getters = {
    nomination: function nomination(_ref8) {
      var nomination = _ref8.nomination;

      return nomination;
    },
    nominations: function nominations(_ref9) {
      var _ref9$nominations = _ref9.nominations,
          nominations = _ref9$nominations === undefined ? [] : _ref9$nominations;

      return nominations.map(function (nomination) {
        return new __WEBPACK_IMPORTED_MODULE_4__nominations__["b" /* Nomination */](nomination);
      });
    },
    nominees: function nominees(_ref10) {
      var nominees = _ref10.nominees;

      return nominees;
    }
  };

  return {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
  };
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    region: null,
    env: null,
    host: null
};

var actions = {
    setRegion: function setRegion(_ref, data) {
        var commit = _ref.commit;

        commit('region', data);
    },
    setEnv: function setEnv(_ref2, data) {
        var commit = _ref2.commit;

        commit('env', data);
    },
    setHost: function setHost(_ref3, data) {
        var commit = _ref3.commit;

        commit('host', data);
    }
};

var mutations = {
    region: function region(state, value) {
        state.region = value;
    },
    env: function env(state, value) {
        state.env = value;
    },
    host: function host(state, value) {
        state.host = value;
    }
};

var getters = {
    contextRegion: function contextRegion(_ref4) {
        var region = _ref4.region;

        return region;
    },
    contextEnv: function contextEnv(_ref5) {
        var env = _ref5.env;

        return env;
    },
    contextHost: function contextHost(_ref6) {
        var host = _ref6.host;

        return host;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
    var state = {
        loader: 0
    };

    var getters = {
        isShowLoader: function isShowLoader(_ref) {
            var loader = _ref.loader;

            if (loader > 0) {
                return true;
            }
            return false;
        }
    };

    var actions = {
        increment: function increment(_ref2) {
            var commit = _ref2.commit;

            commit('increment');
        },
        decrement: function decrement(_ref3) {
            var commit = _ref3.commit;

            commit('decrement');
        }
    };

    var mutations = {
        increment: function increment(state) {
            state.loader += 1;
        },
        decrement: function decrement(state) {
            state.loader -= 1;
        }
    };

    return {
        namespaced: true,
        state: state,
        getters: getters,
        actions: actions,
        mutations: mutations
    };
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_constants_urls__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_types_news__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_helper_string__ = __webpack_require__(241);






var state = {
    newsItem: null,
    newsMain: [],
    news: []
};

var actions = {
    loadNews: function loadNews(_ref, data) {
        var commit = _ref.commit;

        var typeNews = data.context;
        var count = data.count;
        var params = {
            limit: count,
            withCredentials: true
        };

        var host = this.state.context.host;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1_constants_urls__["K" /* NEWS_API_URL */], { params: params }).then(function (result) {
            function pushInNews(item, typeNews) {
                commit(typeNews, item);
            }

            result.data.items.forEach(function (item) {
                pushInNews(item, typeNews);
            });
        }).catch(function (error) {
            console.error(error);
        });
    },
    fetchNews: function fetchNews(_ref2, _ref3) {
        var _this = this;

        var commit = _ref2.commit;
        var context = _ref3.context,
            pager = _ref3.pager;

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.state.context.host + __WEBPACK_IMPORTED_MODULE_1_constants_urls__["K" /* NEWS_API_URL */], {
            params: {
                limit: pager.perPage,
                page_num: pager.num,
                withCredentials: true
            }
        }).then(function (result) {
            function pushInNews(item, typeNews) {
                commit(typeNews, item);
            }
            result.data.items.forEach(function (item) {
                pushInNews(item, context);
                return false;
            });
            var cnt = _this.getters['news/' + context] ? _this.getters['news/' + context].length : 0;
            return { total: result.data.total, count: cnt };
        }).catch(function (error) {
            console.error(error);
        });
    },
    clearNews: function clearNews(_ref4, _ref5) {
        var commit = _ref4.commit;
        var context = _ref5.context;

        commit('clear' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_helper_string__["a" /* ucFirst */])(String(context)));
    }
};

var mutations = {
    newsItem: function newsItem(state, value) {
        state.newsItem = value;
    },
    newsMain: function newsMain(state, value) {
        state.newsMain.push(value);
    },
    clearNewsMain: function clearNewsMain(state) {
        state.newsMain = [];
    },
    news: function news(state, value) {
        state.news.push(value);
    },
    clearNews: function clearNews(state) {
        state.news = [];
    }
};

var getters = {
    newsItem: function newsItem(_ref6) {
        var newsItem = _ref6.newsItem;

        return newsItem;
    },
    news: function news(_ref7) {
        var news = _ref7.news;

        return news.map(function (newsItem) {
            return new __WEBPACK_IMPORTED_MODULE_2_shared_types_news__["a" /* NewsItem */](newsItem);
        });
    },
    newsMain: function newsMain(_ref8) {
        var newsMain = _ref8.newsMain;

        return newsMain.map(function (newsItem) {
            return new __WEBPACK_IMPORTED_MODULE_2_shared_types_news__["a" /* NewsItem */](newsItem);
        });
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);



var state = {
    partners: null
};

var actions = {
    getPartners: function getPartners(_ref) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["l" /* PARTNERS_API_URL */], { withCredentials: true }).then(function (result) {
            commit('partners', result.data);
        }).catch(function (error) {
            console.log(error);
        });
    }
};

var mutations = {
    partners: function partners(state, value) {
        state.partners = value;
    }
};

var getters = {
    partners: function partners(_ref2) {
        var partners = _ref2.partners;

        return partners;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);



var state = {
    currentPhase: null,
    currentPhaseTitle: null,
    votingStages: null,
    votingStagesDescriptions: null,
    votingStagesText: null,
    isAwardsTime: null,
    awardsLink: null
};

var actions = {
    getPhases: function getPhases(_ref) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        var url = host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["L" /* PHASES_API_URL */];

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { withCredentials: true }).then(function (result) {
            commit('currentPhase', result.data.currentStage);
            commit('currentPhaseTitle', result.data.currentStageDescription);
            commit('votingStages', result.data.votingStages);
            commit('votingStagesDescriptions', result.data.votingStagesDescriptions);
            commit('votingStagesText', result.data.votingStagesText);

            if (result.data.awardsTranslation) {
                commit('isAwardsTime', true);
                commit('awardsLink', result.data.awardsTranslation);
            } else {
                commit('isAwardsTime', false);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
};

var mutations = {
    currentPhase: function currentPhase(state, value) {
        state.currentPhase = value;
    },
    currentPhaseTitle: function currentPhaseTitle(state, value) {
        state.currentPhaseTitle = value;
    },
    votingStages: function votingStages(state, value) {
        state.votingStages = value;
    },
    votingStagesDescriptions: function votingStagesDescriptions(state, value) {
        state.votingStagesDescriptions = value;
    },
    votingStagesText: function votingStagesText(state, value) {
        state.votingStagesText = value;
    },
    isAwardsTime: function isAwardsTime(state, value) {
        state.isAwardsTime = value;
    },
    awardsLink: function awardsLink(state, value) {
        state.awardsLink = value;
    }
};

var getters = {
    currentPhase: function currentPhase(_ref2) {
        var currentPhase = _ref2.currentPhase;

        return currentPhase;
    },
    currentPhaseTitle: function currentPhaseTitle(_ref3) {
        var currentPhaseTitle = _ref3.currentPhaseTitle;

        return currentPhaseTitle;
    },
    votingStages: function votingStages(_ref4) {
        var votingStages = _ref4.votingStages;

        return votingStages;
    },
    votingStagesDescriptions: function votingStagesDescriptions(_ref5) {
        var votingStagesDescriptions = _ref5.votingStagesDescriptions;

        return votingStagesDescriptions;
    },
    votingStagesText: function votingStagesText(_ref6) {
        var votingStagesText = _ref6.votingStagesText;

        return votingStagesText;
    },
    isAwardsTime: function isAwardsTime(_ref7) {
        var isAwardsTime = _ref7.isAwardsTime;

        return isAwardsTime;
    },
    awardsLink: function awardsLink(_ref8) {
        var awardsLink = _ref8.awardsLink;

        return awardsLink;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);




var state = {
    success: false,
    successConfirm: false,
    resultTxt: 'Произошла ошибка соединения'
};

var actions = {
    subscribe: function subscribe(_ref, data) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["H" /* SUBSCRIBER_API_URL */], data).then(function (result) {
            commit('subscribe', true);
        }).catch(function (error) {
            commit('subscribe', false);
        });
    },
    confirm: function confirm(_ref2, data) {
        var commit = _ref2.commit;

        var context = data.context;
        var params = {
            token: data.token
        };
        var host = this.state.context.host;

        var action = null;
        if (context === 'activate') {
            action = __WEBPACK_IMPORTED_MODULE_1__constants_urls__["I" /* SUBSCRIBE_API_URL */];
        } else if (context === 'deactivate') {
            action = __WEBPACK_IMPORTED_MODULE_1__constants_urls__["J" /* UNSUBSCRIBE_API_URL */];
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(host + action, data).then(function (result) {
            if (result.status !== 200) {
                commit('successConfirm', false);
            } else {
                commit('successConfirm', true);
                commit('resultTxt', result.data.detail);
            }
        }).catch(function (error) {
            commit('successConfirm', false);
            commit('resultTxt', error.data.detail);
        });
    }
};

var mutations = {
    subscribe: function subscribe(state, value) {
        state.success = value;
    },
    successConfirm: function successConfirm(state, value) {
        state.successConfirm = value;
    },
    resultTxt: function resultTxt(state, value) {
        state.resultTxt = value;
    }
};

var getters = {
    success: function success(_ref3) {
        var success = _ref3.success;

        return success;
    },
    successConfirm: function successConfirm(_ref4) {
        var successConfirm = _ref4.successConfirm;

        return successConfirm;
    },
    resultTxt: function resultTxt(_ref5) {
        var resultTxt = _ref5.resultTxt;

        return resultTxt;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);



var state = {
    aboutText: null,
    aboutMainTopText: null,
    aboutMainBottomText: null,
    afterSubmitText: null,
    beforeAuthText: null,
    documentsText: null,
    membersText: null,
    actionButtonText: null,
    shortListMessage: null,
    partnersText: null,
    year: null,
    liveHeader: null,
    liveTopText: null,
    liveStream: null,
    announcementResultsText: null
};

var actions = {
    getAboutText: function getAboutText(_ref) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["m" /* ABOUT_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('aboutText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getBeforeAuthText: function getBeforeAuthText(_ref2) {
        var commit = _ref2.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["n" /* BEFORE_AUTH_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('beforeAuthText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getMembersText: function getMembersText(_ref3) {
        var commit = _ref3.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["o" /* MEMBERS_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('membersText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getAboutMainTopText: function getAboutMainTopText(_ref4) {
        var commit = _ref4.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["p" /* ABOUT_MAIN_TOP_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('aboutMainTopText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getAboutMainBottomText: function getAboutMainBottomText(_ref5) {
        var commit = _ref5.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["q" /* ABOUT_MAIN_BOTTOM_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('aboutMainBottomText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getAfterSubmitText: function getAfterSubmitText(_ref6) {
        var commit = _ref6.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["r" /* AFTER_SUBMIT_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('afterSubmitText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getDocumentsText: function getDocumentsText(_ref7) {
        var commit = _ref7.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["s" /* DOCUMENTS_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('documentsText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getPartnersText: function getPartnersText(_ref8) {
        var commit = _ref8.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["t" /* PARTNERS_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('partnersText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getActionButtonText: function getActionButtonText(_ref9) {
        var commit = _ref9.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["u" /* ACTION_BUTTON_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('actionButtonText', result.data.content);
            commit('year', result.data.year);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getShortListMessage: function getShortListMessage(_ref10, params) {
        var commit = _ref10.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["v" /* SHORT_LIST_MESSAGE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('shortListMessage', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getLiveHeader: function getLiveHeader(_ref11) {
        var commit = _ref11.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["w" /* LIVE_HEADER_API_URL */], { withCredentials: true }).then(function (result) {
            commit('liveHeader', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getLiveTopText: function getLiveTopText(_ref12) {
        var commit = _ref12.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["x" /* LIVE_TOP_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('liveTopText', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getLiveStream: function getLiveStream(_ref13) {
        var commit = _ref13.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["y" /* LIVE_STREAM_API_URL */], { withCredentials: true }).then(function (result) {
            commit('liveStream', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getAnnouncementResultsText: function getAnnouncementResultsText(_ref14) {
        var commit = _ref14.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["z" /* ANNOUNCEMENT_RESULT_TEXT_API_URL */], { withCredentials: true }).then(function (result) {
            commit('announcementResultsText', result.data.content.trim());
        }).catch(function (error) {
            console.log(error);
        });
    }
};

var mutations = {
    aboutText: function aboutText(state, value) {
        state.aboutText = value;
    },
    membersText: function membersText(state, value) {
        state.membersText = value;
    },
    aboutMainTopText: function aboutMainTopText(state, value) {
        state.aboutMainTopText = value;
    },
    aboutMainBottomText: function aboutMainBottomText(state, value) {
        state.aboutMainBottomText = value;
    },
    afterSubmitText: function afterSubmitText(state, value) {
        state.afterSubmitText = value;
    },
    beforeAuthText: function beforeAuthText(state, value) {
        state.beforeAuthText = value;
    },
    documentsText: function documentsText(state, value) {
        state.documentsText = value;
    },
    documentsTitle: function documentsTitle(state, value) {
        state.documentsTitle = value;
    },
    partnersText: function partnersText(state, value) {
        state.partnersText = value;
    },
    actionButtonText: function actionButtonText(state, value) {
        state.actionButtonText = value;
    },
    shortListMessage: function shortListMessage(state, value) {
        state.shortListMessage = value;
    },
    year: function year(state, value) {
        state.year = value;
    },
    liveHeader: function liveHeader(state, value) {
        state.liveHeader = value;
    },
    liveTopText: function liveTopText(state, value) {
        state.liveTopText = value;
    },
    liveStream: function liveStream(state, value) {
        state.liveStream = value;
    },
    announcementResultsText: function announcementResultsText(state, value) {
        state.announcementResultsText = value;
    }
};

var getters = {
    aboutText: function aboutText(_ref15) {
        var aboutText = _ref15.aboutText;

        return aboutText;
    },
    membersText: function membersText(_ref16) {
        var membersText = _ref16.membersText;

        return membersText;
    },
    aboutMainTopText: function aboutMainTopText(_ref17) {
        var aboutMainTopText = _ref17.aboutMainTopText;

        return aboutMainTopText;
    },
    aboutMainBottomText: function aboutMainBottomText(_ref18) {
        var aboutMainBottomText = _ref18.aboutMainBottomText;

        return aboutMainBottomText;
    },
    afterSubmitText: function afterSubmitText(_ref19) {
        var afterSubmitText = _ref19.afterSubmitText;

        return afterSubmitText;
    },
    beforeAuthText: function beforeAuthText(_ref20) {
        var beforeAuthText = _ref20.beforeAuthText;

        return beforeAuthText;
    },
    documentsText: function documentsText(_ref21) {
        var documentsText = _ref21.documentsText;

        return documentsText;
    },
    documentsTitle: function documentsTitle(_ref22) {
        var documentsTitle = _ref22.documentsTitle;

        return documentsTitle;
    },
    partnersText: function partnersText(_ref23) {
        var partnersText = _ref23.partnersText;

        return partnersText;
    },
    actionButtonText: function actionButtonText(_ref24) {
        var actionButtonText = _ref24.actionButtonText;

        return actionButtonText;
    },
    shortListMessage: function shortListMessage(_ref25) {
        var shortListMessage = _ref25.shortListMessage;

        return shortListMessage;
    },
    eventsYear: function eventsYear(_ref26) {
        var year = _ref26.year;

        return year;
    },
    liveHeader: function liveHeader(_ref27) {
        var liveHeader = _ref27.liveHeader;

        return liveHeader;
    },
    liveTopText: function liveTopText(_ref28) {
        var liveTopText = _ref28.liveTopText;

        return liveTopText;
    },
    liveStream: function liveStream(_ref29) {
        var liveStream = _ref29.liveStream;

        return liveStream;
    },
    announcementResultsText: function announcementResultsText(_ref30) {
        var announcementResultsText = _ref30.announcementResultsText;

        return announcementResultsText;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_urls__ = __webpack_require__(20);



var state = {
    aboutTitle: null,
    membersTitle: null,
    votesTitle: null,
    documentsTitle: null,
    partnersTitle: null,
    newsTitle: null,
    liveTitle: null
};

var actions = {
    getAboutTitle: function getAboutTitle(_ref) {
        var commit = _ref.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["e" /* ABOUT_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('aboutTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getMembersTitle: function getMembersTitle(_ref2) {
        var commit = _ref2.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["f" /* MEMBERS_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('membersTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getVotesTitle: function getVotesTitle(_ref3) {
        var commit = _ref3.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["g" /* VOTES_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('votesTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getDocumentsTitle: function getDocumentsTitle(_ref4) {
        var commit = _ref4.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["h" /* DOCUMENTS_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('documentsTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getPartnersTitle: function getPartnersTitle(_ref5) {
        var commit = _ref5.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["i" /* PARTNERS_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('partnersTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getNewsTitle: function getNewsTitle(_ref6) {
        var commit = _ref6.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["j" /* NEWS_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('newsTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    },
    getLiveTitle: function getLiveTitle(_ref7) {
        var commit = _ref7.commit;

        var host = this.state.context.host;

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(host + __WEBPACK_IMPORTED_MODULE_1__constants_urls__["k" /* LIVE_TITLE_API_URL */], { withCredentials: true }).then(function (result) {
            commit('liveTitle', result.data.content);
        }).catch(function (error) {
            console.log(error);
        });
    }
};

var mutations = {
    aboutTitle: function aboutTitle(state, value) {
        state.aboutTitle = value;
    },
    membersTitle: function membersTitle(state, value) {
        state.membersTitle = value;
    },
    votesTitle: function votesTitle(state, value) {
        state.votesTitle = value;
    },
    documentsTitle: function documentsTitle(state, value) {
        state.documentsTitle = value;
    },
    partnersTitle: function partnersTitle(state, value) {
        state.partnersTitle = value;
    },
    newsTitle: function newsTitle(state, value) {
        state.newsTitle = value;
    },
    liveTitle: function liveTitle(state, value) {
        state.liveTitle = value;
    }
};

var getters = {
    aboutTitle: function aboutTitle(_ref8) {
        var aboutTitle = _ref8.aboutTitle;

        return aboutTitle;
    },
    membersTitle: function membersTitle(_ref9) {
        var membersTitle = _ref9.membersTitle;

        return membersTitle;
    },
    votesTitle: function votesTitle(_ref10) {
        var votesTitle = _ref10.votesTitle;

        return votesTitle;
    },
    documentsTitle: function documentsTitle(_ref11) {
        var documentsTitle = _ref11.documentsTitle;

        return documentsTitle;
    },
    partnersTitle: function partnersTitle(_ref12) {
        var partnersTitle = _ref12.partnersTitle;

        return partnersTitle;
    },
    newsTitle: function newsTitle(_ref13) {
        var newsTitle = _ref13.newsTitle;

        return newsTitle;
    },
    liveTitle: function liveTitle(_ref14) {
        var liveTitle = _ref14.liveTitle;

        return liveTitle;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),

/***/ 287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_urls__ = __webpack_require__(20);





var state = {
  isAuth: false,
  id: null,
  name: null,
  link: null,
  social: null,
  authLinks: null,

  consoleIP: ''
};

var actions = {
  checkUserAuthData: function checkUserAuthData(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var host, url, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              host = _this.state.context.host;
              url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["D" /* USER_INFO_API_URL */];
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                withCredentials: true,
                method: 'GET',
                url: url
              });

            case 5:
              response = _context.sent;


              if (response.status === 200) {
                commit('name', response.data.data.login);
                commit('id', response.data.data.id);
                commit('isAuth', true);
              } else {
                commit('isAuth', false);
              }
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](2);

              commit('isAuth', false);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 9]]);
    }))();
  },
  fetchAuthInfo: function fetchAuthInfo(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var host, url, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              host = _this2.state.context.host;
              url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["E" /* AUTHORIZATION_LINKS_API_URL */];
              _context2.prev = 2;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                withCredentials: true,
                method: 'GET',
                url: url
              });

            case 5:
              response = _context2.sent;


              commit('authLinks', response.data.data);
              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](2);

              console.log(_context2.t0);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 9]]);
    }))();
  },
  signIn: function signIn(_ref3, auth) {
    var _this3 = this;

    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var host, url, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              host = _this3.state.context.host;
              url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["F" /* SIGN_IN_API_URL */];
              _context3.prev = 2;
              _context3.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                withCredentials: true,
                method: 'POST',
                url: url,
                auth: auth
              });

            case 5:
              response = _context3.sent;


              commit('name', response.data.data.login);
              commit('id', response.data.data.id);
              commit('isAuth', true);
              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](2);

              commit('isAuth', false);
              throw _context3.t0.response;

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 11]]);
    }))();
  },
  signOut: function signOut(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var host, url;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              host = _this4.state.context.host;
              url = host + __WEBPACK_IMPORTED_MODULE_3__constants_urls__["G" /* SIGN_OUT_API_URL */];
              _context4.prev = 2;
              _context4.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
                withCredentials: true,
                method: 'POST',
                url: url
              });

            case 5:

              commit('isAuth', false);
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](2);

              console.log(_context4.t0);

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[2, 8]]);
    }))();
  },
  setConsoleIP: function setConsoleIP(_ref5, consoleIP) {
    var commit = _ref5.commit;

    commit('setConsoleIP', consoleIP);
  }
};

var mutations = {
  isAuth: function isAuth(state, value) {
    state.isAuth = value;
  },
  name: function name(state, value) {
    state.name = value;
  },
  link: function link(state, value) {
    state.link = value;
  },
  authLinks: function authLinks(state, value) {
    state.authLinks = value;
  },
  id: function id(state, value) {
    state.id = value;
  },
  social: function social(state, value) {
    state.social = value;
  },
  setConsoleIP: function setConsoleIP(state, value) {
    state.consoleIP = value;
  }
};

var getters = {
  isAuth: function isAuth(_ref6) {
    var isAuth = _ref6.isAuth;

    return isAuth;
  },
  userName: function userName(_ref7) {
    var name = _ref7.name;

    return name;
  },
  userLink: function userLink(_ref8) {
    var link = _ref8.link;

    return link;
  },
  authLinks: function authLinks(_ref9) {
    var authLinks = _ref9.authLinks;

    return authLinks;
  },
  userId: function userId(_ref10) {
    var id = _ref10.id;

    return id;
  },
  userSocial: function userSocial(_ref11) {
    var social = _ref11.social;

    return social;
  },
  consoleIP: function consoleIP(_ref12) {
    var consoleIP = _ref12.consoleIP;

    return consoleIP;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Vote__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutation_types__ = __webpack_require__(118);






/* harmony default export */ __webpack_exports__["a"] = (function () {
    var _mutations;

    var state = {
        votedNominations: []
    };

    var getters = {
        votedNominations: function votedNominations(newState) {
            return newState.votedNominations;
        }
    };

    var actions = {
        proposeNominee: function proposeNominee(_ref, value) {
            var _this = this;

            var commit = _ref.commit,
                dispatch = _ref.dispatch;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var isFetch;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                dispatch('loader/increment', {}, { root: true });
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__services_Vote__["a" /* default */].proposeNominee(value);

                            case 3:
                                isFetch = _context.sent;


                                if (isFetch) {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* PROPOSE_NOMINEE_SUCCESS */], value);
                                } else {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* PROPOSE_NOMINEE_FAILURE */]);
                                }

                                dispatch('loader/decrement', {}, { root: true });

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        fetchVotedNominations: function fetchVotedNominations(_ref2, params) {
            var _this2 = this;

            var commit = _ref2.commit,
                dispatch = _ref2.dispatch;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var votedNominations;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                dispatch('loader/increment', {}, { root: true });
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__services_Vote__["a" /* default */].fetchNominationsVoted(params);

                            case 3:
                                votedNominations = _context2.sent;


                                try {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* FETCH_VOTED_NOMINATION_SUCCESS */], votedNominations);
                                } catch (error) {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* FETCH_VOTED_NOMINATION_FAILURE */], error);
                                }

                                dispatch('loader/decrement', {}, { root: true });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        voteNominee: function voteNominee(_ref3, params) {
            var _this3 = this;

            var commit = _ref3.commit,
                dispatch = _ref3.dispatch;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var resultVoteNominee;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                dispatch('loader/increment', {}, { root: true });
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_3__services_Vote__["a" /* default */].voteNominee(params);

                            case 3:
                                resultVoteNominee = _context3.sent;


                                if (resultVoteNominee.status === 200) {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* VOTE_NOMINEE_SUCCESS */], params);
                                } else if (resultVoteNominee.status === 400) {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* VOTE_NOMINEE_CLOSED */], params);
                                } else {
                                    commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* VOTE_NOMINEE_FAILURE */]);
                                }

                                dispatch('loader/decrement', {}, { root: true });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        clearVoteNominee: function clearVoteNominee(_ref4) {
            var _this4 = this;

            var commit = _ref4.commit;
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                commit(__WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CLEAR_VOTED_NOMINATION */]);

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        }
    };

    var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["a" /* PROPOSE_NOMINEE_SUCCESS */], function (state, data) {
        state.votedNominations.push({
            name: data.name,
            nominationId: Number(data.rubricId),
            id: Number(data.id)
        });

        if (window.fbq) window.fbq('track', 'AddToCart');
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["b" /* PROPOSE_NOMINEE_FAILURE */], function (state) {
        state.error = 'Что то пошло не так, попробуйте еще раз!';
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["c" /* FETCH_VOTED_NOMINATION_SUCCESS */], function (state, data) {
        if (data.length !== 0) {
            state.votedNominations = data;
        }
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["h" /* CLEAR_VOTED_NOMINATION */], function (state) {
        state.votedNominations = [];
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["d" /* FETCH_VOTED_NOMINATION_FAILURE */], function (state, error) {
        state.error = error;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["e" /* VOTE_NOMINEE_SUCCESS */], function (state, data) {
        state.votedNominations.push({
            name: data.name,
            nominationId: Number(data.rubricId),
            id: Number(data.nominantId),
            isRevoteAllowed: true
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["f" /* VOTE_NOMINEE_CLOSED */], function (state, data) {
        state.votedNominations.push({
            nominationId: Number(data.rubricId),
            id: Number(data.nominantId),
            isRevoteAllowed: false
        });
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__mutation_types__["g" /* VOTE_NOMINEE_FAILURE */], function (state, error) {
        state.error = error;
    }), _mutations);

    return {
        namespaced: true,
        state: state,
        getters: getters,
        actions: actions,
        mutations: mutations
    };
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(226);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(160)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(586),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 584:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(160)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(585),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 585:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/About.vue": [
		598,
		21
	],
	"./archive/Archive.vue": [
		599,
		29
	],
	"./archiveWinners/ArchiveWinners.vue": [
		600,
		16
	],
	"./docs/Docs.vue": [
		601,
		37
	],
	"./home/Home.vue": [
		602,
		9
	],
	"./members/Members.vue": [
		603,
		30
	],
	"./news/News.vue": [
		604,
		4
	],
	"./notFound/NotFound.vue": [
		605,
		39
	],
	"./partners/Partners.vue": [
		606,
		38
	],
	"./votes/Votes.vue": [
		607,
		19
	],
	"./votesForm/VotesForm.vue": [
		608,
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 594;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/About.vue": [
		610,
		15
	],
	"./archive/Archive.vue": [
		611,
		24
	],
	"./archiveWinners/ArchiveWinners.vue": [
		612,
		25
	],
	"./docs/Docs.vue": [
		613,
		32
	],
	"./home/Home.vue": [
		614,
		10
	],
	"./live/Live.vue": [
		615,
		26
	],
	"./members/Members.vue": [
		616,
		17
	],
	"./news/News.vue": [
		617,
		3
	],
	"./notFound/NotFound.vue": [
		618,
		36
	],
	"./partners/Partners.vue": [
		619,
		33
	],
	"./votes/Votes.vue": [
		620,
		7
	],
	"./votesForm/VotesForm.vue": [
		621,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 595;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./about/About.vue": [
		623,
		20
	],
	"./archive/Archive.vue": [
		624,
		23
	],
	"./archiveWinners/ArchiveWinners.vue": [
		625,
		22
	],
	"./docs/Docs.vue": [
		626,
		35
	],
	"./home/Home.vue": [
		627,
		8
	],
	"./kontur/Kontur.vue": [
		628,
		27
	],
	"./live/Live.vue": [
		629,
		18
	],
	"./members/Members.vue": [
		630,
		14
	],
	"./news/News.vue": [
		631,
		2
	],
	"./notFound/NotFound.vue": [
		632,
		34
	],
	"./partners/Partners.vue": [
		633,
		31
	],
	"./votes/Votes.vue": [
		634,
		6
	],
	"./votesForm/VotesForm.vue": [
		635,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 596;

/***/ })

},[272]);


// WEBPACK FOOTER //
// static/js/app.b493e22859e0e8b88cba.js